"use client";

import { Link } from "@packages/framework";

import type { IconButtonProps } from "../../../_base/_core/IconButton/IconButton";
import { IconButton } from "../../../_base/_core/IconButton/IconButton";
import type { IconElement } from "../../../_base/icons/Icon/Icon";
import { ArrowLeftIcon } from "../../../_base/icons/Icon/NavigationIcons";

export type BackButtonProps = Omit<IconButtonProps, "icon"> & {
  icon?: IconElement;
  backHref?: string;
};

export const BackButton = ({
  icon = <ArrowLeftIcon />,
  backHref,
  onClick,
  ...props
}: BackButtonProps) => (
  <IconButton
    icon={icon}
    onClick={(e) => {
      if (onClick) onClick(e);
      !backHref && window?.history?.back();
    }}
    asChild={!!backHref}
    {...props}
  >
    {backHref && <Link href={backHref} />}
  </IconButton>
);
